import React, { useState, useEffect } from 'react';
import { MenuIcon, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-apple' : 'bg-transparent'
      }`}
    >
      <div className="container flex items-center justify-between h-20">
        <div className="flex items-center">
          <Link to="/" className="text-2xl font-medium">
            <img src="/img/logo.png" alt="RepliGo（レプリゴ）" className="h-12" />
          </Link>
        </div>

        {/* Desktop navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {isHomePage ? (
            <>
              <a href="#features" className="text-gray-700 hover:text-blue-600 transition-colors">Features</a>
              <a href="#testimonials" className="text-gray-700 hover:text-blue-600 transition-colors">Testimonials</a>
              <a href="#pricing" className="text-gray-700 hover:text-blue-600 transition-colors">Pricing</a>
              <a href="#faq" className="text-gray-700 hover:text-blue-600 transition-colors">FAQ</a>
            </>
          ) : (
            <>
              <Link to="/#features" className="text-gray-700 hover:text-blue-600 transition-colors">Features</Link>
              <Link to="/#testimonials" className="text-gray-700 hover:text-blue-600 transition-colors">Testimonials</Link>
              <Link to="/#pricing" className="text-gray-700 hover:text-blue-600 transition-colors">Pricing</Link>
              <Link to="/#faq" className="text-gray-700 hover:text-blue-600 transition-colors">FAQ</Link>
            </>
          )}
          {isHomePage ? (
            <a href="#pricing" className="btn btn btn-primary">Get Started Now</a>
          ) : (
            <Link to="/#pricing" className="btn btn btn-primary">Get Started Now</Link>
          )}
          <a href="/app" className="btn btn-secondary ring-2 ring-gray-400">ログイン</a>
        </nav>

        {/* Mobile menu button */}
        <button 
          className="md:hidden text-gray-700"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? <X size={24} /> : <MenuIcon size={24} />}
        </button>
      </div>

      {/* Mobile navigation */}
      {isMenuOpen && (
        <div className="md:hidden bg-white">
          <div className="container py-4 space-y-3">
            {isHomePage ? (
              <>
                <a href="#features" className="block py-2 text-gray-700" onClick={toggleMenu}>Features</a>
                <a href="#pricing" className="block py-2 text-gray-700" onClick={toggleMenu}>Pricing</a>
                <a href="#testimonials" className="block py-2 text-gray-700" onClick={toggleMenu}>Testimonials</a>
                <a href="#faq" className="block py-2 text-gray-700" onClick={toggleMenu}>FAQ</a>
              </>
            ) : (
              <>
                <Link to="/#features" className="block py-2 text-gray-700" onClick={toggleMenu}>Features</Link>
                <Link to="/#pricing" className="block py-2 text-gray-700" onClick={toggleMenu}>Pricing</Link>
                <Link to="/#testimonials" className="block py-2 text-gray-700" onClick={toggleMenu}>Testimonials</Link>
                <Link to="/#faq" className="block py-2 text-gray-700" onClick={toggleMenu}>FAQ</Link>
              </>
            )}
            <div className="pt-4 space-y-3">
              {isHomePage ? (
                <a href="#pricing" className="block w-full text-center btn btn-secondary" onClick={toggleMenu}>Get Started Now</a>
              ) : (
                <Link to="/#pricing" className="block w-full text-center btn btn-secondary" onClick={toggleMenu}>Get Started Now</Link>
              )}
              <a href="/app" className="block w-full text-center btn btn-primary">ログイン</a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;